class BundleSelector extends HTMLElement {
  connectedCallback() {
    this.root = (window.Shopify?.routes?.root) || '/';
    if (this.root !== '/' && !this.root.endsWith('/')) this.root += '/';
    this.mainVid = this.dataset.mainVid;
    this.sel = {};
    this.querySelectorAll('.bundle-group').forEach((g, i) => {
      this.sel[i] = [];
      g.querySelector('.bundle-group__header')?.addEventListener('click', () => g.toggleAttribute('open'));
      g.querySelectorAll('.bundle-item').forEach(item => {
        item.querySelector('.bundle-item__btn')?.addEventListener('click', () => this.addItem(item, i));
        item.querySelector('.bundle-item__var')?.addEventListener('change', e => {
          const o = e.target.selectedOptions[0];
          item.dataset.vid = o.value;
          item.dataset.iid = o.dataset.iid || '';
          item.dataset.p = o.dataset.p;
          if (o.dataset.name) item.dataset.varName = o.dataset.name;
        });
      });
    });
    this.querySelector('.bundle-foot__btn')?.addEventListener('click', () => this.addToCart());
    this.refresh();
  }

  addItem(item, gi) {
    const g = item.closest('.bundle-group');
    const max = parseInt(g.dataset.max) || 99;
    if (this.sel[gi].length >= max) return;
    const varSelect = item.querySelector('.bundle-item__var');
    const varName = varSelect ? (varSelect.selectedOptions[0]?.dataset?.name || item.dataset.name) : item.dataset.name;
    this.sel[gi].push({
      pid: item.dataset.pid,
      vid: item.dataset.vid,
      iid: item.dataset.iid || '',
      img: item.dataset.img || '',
      name: item.dataset.name,
      varName
    });
    this.refresh();
  }

  removeItem(gi, pid) {
    const idx = this.sel[gi].findIndex(s => s.pid === pid);
    if (idx > -1) this.sel[gi].splice(idx, 1);
    this.refresh();
  }

  refresh() {
    this.querySelectorAll('.bundle-group').forEach((g, i) => {
      const min = parseInt(g.dataset.min) || 0;
      const max = parseInt(g.dataset.max) || 1;
      const cnt = this.sel[i]?.length || 0;
      const status = g.querySelector('.bundle-group__status');
      if (status) status.textContent = cnt > 0 ? '已加入 ' + cnt + '件' : '';
      const fill = g.querySelector('.bundle-group__bar-fill');
      if (fill) fill.style.width = Math.min(cnt / max * 100, 100) + '%';
      g.querySelectorAll('.bundle-item').forEach(item => {
        item.classList.toggle('bundle-item--added', !!this.sel[i]?.some(s => s.pid === item.dataset.pid));
      });
      const selC = g.querySelector('.bundle-selected');
      if (selC) {
        selC.innerHTML = (this.sel[i] || []).map(s =>
          '<div class="bundle-sel-item" data-pid="' + s.pid + '">' +
          '<span class="bundle-sel-item__name">' + (s.varName || s.name) + '</span>' +
          '<div class="bundle-sel-item__actions">' +
          '<button type="button" class="bundle-sel-item__btn" data-action="remove">🗑</button>' +
          '<span class="bundle-sel-item__qty">1</span>' +
          '<button type="button" class="bundle-sel-item__btn" data-action="add">+</button>' +
          '</div></div>'
        ).join('');
        selC.querySelectorAll('.bundle-sel-item__btn').forEach(btn => {
          btn.addEventListener('click', () => {
            const pid = btn.closest('.bundle-sel-item').dataset.pid;
            if (btn.dataset.action === 'remove') this.removeItem(i, pid);
            else { const item = g.querySelector('.bundle-item[data-pid="' + pid + '"]'); if (item) this.addItem(item, i); }
          });
        });
      }
    });
    let ok = true;
    this.querySelectorAll('.bundle-group').forEach((g, i) => {
      if (g.dataset.required === 'true' && (this.sel[i]?.length || 0) < (parseInt(g.dataset.min) || 0)) ok = false;
    });
    this.querySelector('.bundle-foot__btn').disabled = !ok;
  }

  async addToCart() {
    const btn = this.querySelector('.bundle-foot__btn');
    if (!btn || btn.disabled) return;
    const txt = btn.textContent;
    btn.disabled = true; btn.textContent = '...';

    const props = { _bundle: 'true' };
    const inventoryItems = [];
    const bundleItems = [];
    this.querySelectorAll('.bundle-group').forEach((g, i) => {
      const title = g.dataset.title || ('Group ' + (i + 1));
      const names = [];
      (this.sel[i] || []).forEach(s => {
        names.push(s.varName || s.name);
        if (s.iid) inventoryItems.push(s.iid);
        bundleItems.push({ name: s.varName || s.name, img: s.img, group: title });
      });
      if (names.length) props[title] = names.join(' / ');
    });
    props['_bundle_inventory_items'] = inventoryItems.join(',');
    props['_bundle_items_json'] = JSON.stringify(bundleItems);

    try {
      const r = await fetch(this.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(this.mainVid), quantity: 1, properties: props }]
        })
      });
      if (!r.ok) { const e = await r.json(); alert(e.description || 'Error'); return; }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.location.href = this.root + 'cart';
    } catch (e) { alert('Error'); } finally { btn.disabled = false; btn.textContent = txt; }
  }
}
if (!customElements.get('bundle-selector')) customElements.define('bundle-selector', BundleSelector);
